module.exports = __webpack_public_path__ + "static/12-edff794bc5a06178fca446d9273e5cfc.png";